import React from 'react';
import '../App.css'
const NotFoundPage = ({ NotFoundLinkLabel, NotFoundLinkSrc }) => {

    // Todo: Add an {LinkTitle} and {LinkSrc} thingy like before.

    const notFoundPageStyles = {
        margin: 0,
        textAlign: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: 18,
    };

    const textContainerStyles = {
        margin: 0,
        color: "#FF5F5F",
    };

    const linksContainer = {
        color: "#07F"
    }



    return (
        <div className='notfoundpage' style={notFoundPageStyles}>
            <div id="notfound-text-container" style={textContainerStyles}>
                <h2 style={{ fontWeight: "600" }}>Oh Snap.</h2>
                <p>It looks like that page dosen't exist...<br/>
                   But Here's Some Useful links:</p>
            </div>
            <div style={linksContainer}>
                <a href={"/?utm_source=notfoundpage"} style={linksContainer}>Home</a> <br/>
                <a href={"/"} style={linksContainer}>Temp 0</a> <br/>
                <a href={NotFoundLinkSrc} style={linksContainer}>Temp 1</a> <br/>
                <span>DEV NOTE: This page isn't finished, and needs to be redesigned.</span>
            </div>
        </div>
    );
};

export default NotFoundPage;